import setCommonWellItemSelectedState from 'owa-readwrite-common-well/lib/actions/setCommonWellItemSelectedState';
import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import ReadWriteRecipientViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('focusNextRecipient')(function focusNextRecipient(
    recipientWell: RecipientWellWithFindControlViewState,
    recipientToBlur: ReadWriteRecipientViewState | number,
    direction: number
) {
    let indexToBlur;
    if (typeof recipientToBlur === 'number') {
        indexToBlur = recipientToBlur;
    } else {
        indexToBlur = recipientWell.recipients.indexOf(recipientToBlur);
    }
    if (indexToBlur >= 0) {
        let indexToFocus = Math.max(0, indexToBlur + direction);
        if (indexToFocus < recipientWell.recipients.length) {
            setCommonWellItemSelectedState(recipientWell.recipients[indexToFocus], true);
        }
    }
});
